import React, { FC } from 'react';
import { TruncatedText } from './TruncatedText';

interface HighlightedTextProps {
  searchTerm?: string;
  textContent: string;
}

const regexForSpecialCharacters = /([.?*+^$[\]\\(){}|-])/g;

const getSearchPattern = (str?: string) => str?.replace(regexForSpecialCharacters, '\\$1');

export const HighlightedTruncatedText: FC<HighlightedTextProps> = ({ searchTerm, textContent }) => {
  const pattern = new RegExp(`(${getSearchPattern(searchTerm)})`, 'i');
  const parts = textContent.toString().split(pattern);

  return (
    <TruncatedText label={textContent} className='max-w-full text-lg leading-7'>
      {searchTerm &&
        parts.map((part, index) =>
          pattern.test(part) ? (
            <span data-testid='highlighted-part' className='text-black-default font-bold' key={`${part}-${index}`}>
              {part}
            </span>
          ) : (
            <span key={`${part}-${index}`}>{part}</span>
          )
        )}
    </TruncatedText>
  );
};
